import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from "../../services/analytics.service";
import './form-item-hs-vas-statistics.component.scss';
var FormItemHsVasStatistics = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemHsVasStatistics, _super);
    function FormItemHsVasStatistics(element) {
        return _super.call(this, element) || this;
    }
    FormItemHsVasStatistics.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.successMessage = this.form.querySelector(".form__success--container");
        this.errorMessage = this.form.querySelector(".form__serror--container");
        this.submitButton = Array.from(this.element.querySelectorAll('.js-hs-vas-statistics__button'));
    };
    FormItemHsVasStatistics.prototype.bindEvents = function () {
        var _this = this;
        this.submitButton.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
            }
        }); });
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            if (_this.errorMessage) {
                _this.errorMessage.classList.remove('active');
            }
            if (_this.successMessage) {
                _this.successMessage.classList.remove('active');
            }
        }, false);
    };
    FormItemHsVasStatistics.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // fields
        var requiredProfession = form.querySelector('input[name=profession]');
        var suburb = form.querySelector('input[name=suburb]');
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var fields = 'vicinitiesparams=' + ((requiredProfession) ? requiredProfession.value : '') + ',' + ((suburb) ? suburb.value : '');
        var analyticsService = new AnalyticsService();
        var url = "/homeservices/sbhsvicinities";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, fields, config).then(function (response) {
            // service ok
            analyticsService.dtmFormComplete('complete', 'true');
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            thankYou.classList.add('active');
            success.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('active');
            thankYou.classList.remove('active');
            error.classList.add('active');
        });
    };
    return FormItemHsVasStatistics;
}(Base));
export { FormItemHsVasStatistics };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-hs-vas-statistics/form-item-hs-vas-statistics.component.ts
// module id = 923
// module chunks = 0